export const profileType = {
    EMPLOYEE: 'employee',
    APPLICATION: 'application'
  };